// Funciones de lógica y handlers para Navbar
import { GUARANTEE_MARK_LABEL } from '../../utils/constants'

// Nombre de la marca en mayúsculas si el usuario es especial y tiene marca; si no, null.
export const getSpecialMarkLabel = (userData) => {
  const label = userData?.isSpecial ? GUARANTEE_MARK_LABEL[userData.markType] : null
  return label ? label.toUpperCase() : null
}

export const getColorClass = (URL, userData, classes) => {
  if (URL.client) {
    if (userData.porcAvailable >= 90 || userData.blockedGuarantee) {
      return classes.guaranteeValueDanger
    } else if (userData.porcAvailable < 90 && userData.porcAvailable > 70) {
      return classes.guaranteeValueWarning
    } else {
      return classes.guaranteeValue
    }
  }
}

export const toggleDrawer = (openDrawer, setOpenDrawer) => {
  setOpenDrawer(!openDrawer)
}

export const handleSettingsClick = (event, setSettingsEl) => {
  setSettingsEl(event.currentTarget)
}

export const handleUserClick = (event, userData, setUserEl) => {
  if (userData) setUserEl(event.currentTarget)
}

export const handleClose = (loadingUpdate, setUserEl, setSettingsEl) => {
  if (!loadingUpdate) {
    setUserEl(null)
    setSettingsEl(null)
  }
}

export const logout = (setUserEl, history) => {
  setUserEl(null)
  history.push('/logout')
}

export const restartTutorial = (setUserEl, setShowTutorial) => {
  setUserEl(null)
  setShowTutorial(true)
}

export const syncUserGuarantee = (setUserData, socketUser, auction, userData) => {
  setUserData((user) => ({ ...user, loadingUserGuarantee: true }))
  socketUser.emit('getGuarantee', {
    auctionId: auction.id,
    userId: userData.externalId,
  })
}

export const restartAuction = (socketAdmin, auction, userData) => {
  socketAdmin.emit('restartAuction', {
    auctionId: auction.id,
    areaId: auction.areaId,
    token: userData.token,
  })
}

export const updateAuction = (setLoadingUpdate, socketAdmin, auction, userData) => {
  setLoadingUpdate(true)
  socketAdmin.emit('updateAuction', {
    auctionId: auction.id,
    areaId: auction.areaId,
    token: userData.token,
  })
}

export const getAuctionType = (auction, setAuctionType) => {
  if (auction?.auctionTypeId) {
    if (auction.auctionTypeId === 1 || auction.auctionTypeId === 2) {
      setAuctionType("REMATES ONLINE")
    } else if (auction.auctionTypeId === 3 || auction.auctionTypeId === 4) {
      setAuctionType("LICITACIÓN ONLINE")
    } else {
      setAuctionType("LICITACIÓN/REMATE ONLINE")
    }
  }
}
